import { ICoreFrameGridOptions, ICoreFrameGridPagingOptions } from "../Interfaces";
import { CoreFrameGrid } from "../index";
import { Constants } from "../Constants";
import { EventHelper } from "../Components/EventHelper";

export class Footer {
    private grid: CoreFrameGrid;
    private eventHelper: EventHelper;
    private $wrapper: JQuery<HTMLElement>;
    private $summaryRow: JQuery<HTMLElement>;
    private $paging: JQuery<HTMLElement>;
    private pageSizesWrapper: HTMLDivElement;
    private optionsWrapper: HTMLDivElement;
    private pagesWrapper: HTMLDivElement;

    private pageSizesOpen: boolean;

    private currentPage = undefined;
    private totalPages = undefined;
    private totalRows = undefined;
    private pageSize = undefined;
    private pageSizes = undefined;

    constructor(private options: ICoreFrameGridOptions, grid: CoreFrameGrid, eventHelper: EventHelper) {
        this.grid = grid;
        this.eventHelper = eventHelper;
        this.initFooter();
    }

    private initFooter() {
        this.pageSizesOpen = false;
        this.$wrapper = $('<div class="' + Constants.FOOTER_CLASS_PREFIX + '">');

        if (!this.isFooterVisible())
            this.$wrapper.css('display', 'none');
        else {
            if (this.isSummaryRowEnabled()) {
                this.initSummaryRow();
                this.$wrapper.append(this.$summaryRow);
            }
            if (this.isPagingEnabled()) {
                this.initPaging();
                this.$wrapper.append(this.$paging);
            }
        }
    }

    public isFooterVisible(): boolean {
        let isPagingEnabled = this.isPagingEnabled();
        let isSummaryRowEnabled = this.isSummaryRowEnabled();
        return isPagingEnabled || isSummaryRowEnabled;
    }

    private initSummaryRow() {
        if (!this.$summaryRow)
            this.$summaryRow = $('<span class="' + Constants.FOOTER_CLASS_SUMMARYROW + '">');

        this.$summaryRow.empty();

        let summaryRowContent = '';

        if (this.options.summaryRow.preText) {
            summaryRowContent += '<span';
            if (this.grid.useLocator())
                summaryRowContent += ' data-locator="' + this.options.locator + '.summaryrow.total.pre"';
            summaryRowContent += '>' + this.options.summaryRow.preText + '</span>';
        }

        summaryRowContent += '<span';
        if (this.grid.useLocator())
            summaryRowContent += ' data-locator="' + this.options.locator + '.summaryrow.total.rowcount"';
        summaryRowContent += '>';
        if(this.options.summaryRow.text)
            summaryRowContent += this.options.summaryRow.text;
        else
            summaryRowContent += (this.totalRows || this.grid.getTotalRows());
        summaryRowContent + '</span>';

        if (this.options.summaryRow.postText) {
            summaryRowContent += '<span';
            if (this.grid.useLocator())
                summaryRowContent += ' data-locator="' + this.options.locator + '.summaryrow.total.post"';
            summaryRowContent += '>' + this.options.summaryRow.postText + '</span>';
        }

        this.$summaryRow.append(summaryRowContent);
    }

    private initPaging() {
        if (!this.$paging) {
            this.$paging = $('<div>');
            this.$paging.addClass(Constants.FOOTER_CLASS_PAGING);

            this.pageSizesWrapper = document.createElement('div') as HTMLDivElement;
            this.pageSizesWrapper.classList.add(Constants.FOOTER_CLASS_PAGESIZE);

            this.optionsWrapper = document.createElement('div') as HTMLDivElement;
            this.optionsWrapper.classList.add(Constants.FOOTER_CLASS_PAGESIZE_OPTIONSWRAPPER);
            this.optionsWrapper.classList.add(Constants.FOOTER_CLASS_PAGESIZE_OPTIONSWRAPPER_HIDDEN);

            this.pagesWrapper = document.createElement('div') as HTMLDivElement;
            this.pagesWrapper.classList.add(Constants.FOOTER_CLASS_PAGES);

            this.$paging.css('position', 'relative');



            // Klick auf eine Seitengröße
            this.$paging.on(Constants.EVENT_CLICK, '.' + Constants.FOOTER_CLASS_PAGESIZE_OPTION, (ev) => {
                ev.stopPropagation();
                this.resetShiftKlick();
                if (typeof this.options.paging.onPageSizeChanged == "function") {
                    let newValue = parseInt(ev.currentTarget.textContent);
                    this.options.paging.onPageSizeChanged(newValue);
                    this.options.paging.onPageChanged(1);
                    this.closePageSizes();
                }
            });

            // Klick zum Öffnen der Seitengrößen
            this.$paging.on(Constants.EVENT_CLICK, '.' + Constants.FOOTER_CLASS_PAGESIZE, (ev) => {
                ev.stopPropagation();
                if (this.optionsWrapper.classList.contains(Constants.FOOTER_CLASS_PAGESIZE_OPTIONSWRAPPER_HIDDEN)) {
                    this.openPageSizes();
                }
                else {
                    this.closePageSizes();
                }
            });

            this.eventHelper.registerOnHtmlBodyClick(() => {
                if (this.pageSizesOpen) {
                    this.closePageSizes();
                }
            });

            // Klick zum Wechsel der Seite
            this.$paging.on(Constants.EVENT_CLICK, '.' + Constants.FOOTER_CLASS_PAGE, (ev) => {
                if (ev.currentTarget &&
                    (ev.currentTarget.classList.contains(Constants.FOOTER_CLASS_PAGE_ACTIVE) || ev.currentTarget.classList.contains(Constants.FOOTER_CLASS_PAGE_DISABLED)))
                    return;

                this.resetShiftKlick();
                let newPage = parseInt($(ev.currentTarget).data('page'));

                if (this.currentPage != newPage) {
                    this.currentPage = newPage;
                    this.options.paging.currentPage = newPage;

                    this.redrawPages();

                    if (typeof this.options.paging.onPageSizeChanged == "function") {
                        this.options.paging.onPageChanged(newPage);
                    }
                }
            });
        }
        this.optionsWrapper.innerHTML = '';
        this.pageSizesWrapper.innerHTML = '';
        this.pagesWrapper.innerHTML = '';

        if (this.isPagingEnabled()) {
            this.redrawPages();

            if (this.pageSizes) {
                let pageSize = '<span class="' + Constants.FOOTER_CLASS_PAGESIZE_CURRENT + '"';
                if (this.grid.useLocator())
                    pageSize += ' data-locator="' + this.options.locator + '.page-size-select"';
                pageSize += '>' + this.pageSize + '</span>';

                let options = '';
                this.pageSizes.forEach((element) => {
                    options += '<span class="' + Constants.FOOTER_CLASS_PAGESIZE_OPTION + '"';
                    if (this.grid.useLocator())
                        options += ' data-locator="' + this.options.locator + '.page-size-select.' + element + '"';
                    options += '>' + element + '</span>';
                });
                this.optionsWrapper.innerHTML = options;

                this.pageSizesWrapper.innerHTML = pageSize;
                this.pageSizesWrapper.appendChild(this.optionsWrapper)
                this.$paging[0].appendChild(this.pagesWrapper);
                this.$paging[0].appendChild(this.pageSizesWrapper);
            }
        }
    }

    private resetShiftKlick() {
        // Wird ein Seitenwechsel durchgeführt, so müssen die Hilfsvariablen für Shift-Klick resettet werden
        this.grid.getEventHelper().resetShiftKlick();
    }

    private openPageSizes() {
        this.pageSizesOpen = true;
        this.optionsWrapper.classList.remove(Constants.FOOTER_CLASS_PAGESIZE_OPTIONSWRAPPER_HIDDEN);
        this.optionsWrapper.classList.add(Constants.FOOTER_CLASS_PAGESIZE_OPTIONSWRAPPER_VISIBLE);
        this.optionsWrapper.style.top = '-' + this.optionsWrapper.offsetHeight + 'px';
    }

    private closePageSizes() {
        this.pageSizesOpen = false;
        this.optionsWrapper.classList.remove(Constants.FOOTER_CLASS_PAGESIZE_OPTIONSWRAPPER_VISIBLE);
        this.optionsWrapper.classList.add(Constants.FOOTER_CLASS_PAGESIZE_OPTIONSWRAPPER_HIDDEN);
    }

    private redrawPages() {
        let pages = '';

        // Indizes berechnen
        let startIndex = 1;
        let endIndex = this.totalPages;
        if (this.totalPages > 10) {
            let mod = this.currentPage % 10;
            // Bspw.: 10 = 1, 20 = 11, 30 = 21 usw..
            if (mod == 0)
                startIndex = (((this.currentPage / 10) - 1) * 10) + 1;
            else
                startIndex = this.currentPage - (this.currentPage % 10) + 1;

            endIndex = startIndex + 9;

            if (endIndex > this.totalPages)
                endIndex = this.totalPages;
        }

        // Zum Start
        pages += '<span class="';
        pages += Constants.FOOTER_CLASS_PAGE + ' ' + Constants.FOOTER_CLASS_PAGE_START;
        pages += (this.currentPage == 1 ? ' ' + Constants.FOOTER_CLASS_PAGE_DISABLED : '') + '"';
        pages += (this.currentPage == 1 ? '' : ' data-page="' + 1 + '"');
        pages += (this.grid.useLocator() ? ' data-locator="' + this.options.locator + '.page.first"' : '')
        pages += '></span>';

        // Zurück
        pages += '<span class="';
        pages += Constants.FOOTER_CLASS_PAGE + ' ' + Constants.FOOTER_CLASS_PAGE_PREVIOUS;
        pages += (this.currentPage == 1 ? ' ' + Constants.FOOTER_CLASS_PAGE_DISABLED : '') + '"';
        pages += (this.currentPage == 1 ? '' : ' data-page="' + (this.currentPage - 1) + '"');
        pages += (this.grid.useLocator() ? ' data-locator="' + this.options.locator + '.page.prev"' : '');
        pages += '></span>';

        // weitere Seiten vorher
        if (this.totalPages > 10 && this.currentPage > 10) {
            let x = startIndex - 1;
            pages += '<span class="' + Constants.FOOTER_CLASS_PAGE + '"';
            pages += ' data-page="' + x + '"';
            pages += (this.grid.useLocator() ? ' data-locator="' + this.options.locator + '.page.[' + x + ']"' : '');
            pages += '>...</span>';
        }

        // Seitenzahlen
        for (let x = startIndex; x <= endIndex; x++) {
            pages += '<span class="';
            pages += Constants.FOOTER_CLASS_PAGE + (x == this.currentPage ? ' ' + Constants.FOOTER_CLASS_PAGE_ACTIVE : '') + '"';
            pages += ' data-page="' + x + '"';
            pages += (this.grid.useLocator() ? ' data-locator="' + this.options.locator + '.page.[' + x + ']"' : '');
            pages += '>' + x + '</span>';
        }

        // weitere Seiten nachher
        if (endIndex < this.totalPages) {
            let x = endIndex + 1;
            pages += '<span class="' + Constants.FOOTER_CLASS_PAGE + '"';
            pages += ' data-page="' + x + '"';
            pages += (this.grid.useLocator() ? ' data-locator="' + this.options.locator + '.page.[' + x + ']"' : '');
            pages += '>...</span>';
        }

        // Vor
        pages += '<span class="';
        pages += Constants.FOOTER_CLASS_PAGE + ' ' + Constants.FOOTER_CLASS_PAGE_NEXT;
        pages += (this.currentPage == this.totalPages ? ' ' + Constants.FOOTER_CLASS_PAGE_DISABLED : '') + '"';
        pages += (this.currentPage == this.totalPages ? '' : ' data-page="' + (this.currentPage + 1) + '"');
        pages += (this.grid.useLocator() ? ' data-locator="' + this.options.locator + '.page.next"' : '');
        pages += '></span>';

        // Zum Ende
        pages += '<span class="';
        pages += Constants.FOOTER_CLASS_PAGE + ' ' + Constants.FOOTER_CLASS_PAGE_END;
        pages += (this.currentPage == this.totalPages ? ' ' + Constants.FOOTER_CLASS_PAGE_DISABLED : '') + '"';
        pages += (this.currentPage == this.totalPages ? '' : ' data-page="' + this.totalPages + '"');
        pages += (this.grid.useLocator() ? ' data-locator="' + this.options.locator + '.page.last"' : '');
        pages += '></span>';

        this.pagesWrapper.innerHTML = pages;

        if (this.totalPages == 1)
            this.pagesWrapper.classList.add(Constants.FOOTER_CLASS_PAGES_DISABLED)
        else
            this.pagesWrapper.classList.remove(Constants.FOOTER_CLASS_PAGES_DISABLED);
    }

    public isPagingEnabled(): boolean {
        return this.options.paging && this.options.paging.isEnabled;
    }

    public isSummaryRowEnabled(): boolean {
        return this.options.summaryRow && this.options.summaryRow.isEnabled;
    }

    public updatePaging(paging: ICoreFrameGridPagingOptions) {
        let reInit = false;
        if (this.currentPage != paging.currentPage) {
            this.currentPage = paging.currentPage;
            reInit = true;
        }

        if (this.pageSize != paging.pageSize) {
            this.pageSize = paging.pageSize;
            reInit = true;
        }

        if (this.pageSizes != paging.pageSizes) {
            this.pageSizes = paging.pageSizes;
            reInit = true;
        }

        let totalRows = this.options.paging.totalRows || this.grid.getTotalRows();
        if (this.totalRows != totalRows) {
            this.totalRows = totalRows;
            reInit = true;
        }

        this.totalPages = this.totalRows / this.options.paging.pageSize;
        if (this.totalPages % 1 !== 0)
            this.totalPages = parseInt(this.totalPages + '') + 1;

        if (this.totalPages < 1)
            this.totalPages = 1;

        if (reInit) {
            this.initPaging();
            this.updateSummaryRow();
        }
    }

    public updateSummaryRow() {
        this.initSummaryRow();
    }

    public getWrapper() {
        return this.$wrapper;
    }
}
